module.exports = __webpack_public_path__ + "img/69.2f139a31.jpg";